import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const DebitCardWrapperStyle = ({ usedAtDashboard, isLatest, theme }) => ({
  width: '100%',
  height: 'auto',
  padding: `${usedAtDashboard ? '18px 0' : '24px 0'}`,
  display: 'flex',
  borderBottom: `${isLatest && usedAtDashboard ? 'none' : '1px solid'}`,
  borderColor: theme.palette.border.main,
  justifyContent: 'space-between',
  alignItems: 'center'
});

const LabelStyle = () => ({
  padding: '4px 12px',
  borderRadius: '16px',
  border: 'none',
  width: 'fit-content'
});

export const DebitCardWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'usedAtDashboard' && prop !== 'isLatest'
})(DebitCardWrapperStyle);
export const LabelStyled = styled(Stack)(LabelStyle);
